import React, { FC, memo, PropsWithChildren, ReactNode, useMemo, useRef } from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalContent,
  ModalCloseButton,
  Spinner,
  ModalContentProps,
} from '@chakra-ui/react';

import { LayoutContext } from '../layout';
interface DialogProps extends PropsWithChildren, Pick<ModalContentProps, 'width'> {
  title?: ReactNode;
  open: boolean;
  onClose(): void;
  actions?: ReactNode;
  loading?: boolean;
  headless?: boolean;
  noscroll?: boolean;
  footerless?: boolean;
}

export const DialogComponent: FC<DialogProps> = (props) => {
  const {
    title,
    open,
    onClose,
    children,
    actions,
    loading,
    headless,
    noscroll,
    width,
    footerless,
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  return (<LayoutContext.Provider value={useMemo(() => ({ containerRef }), [])}>
    <Modal isOpen={open} onClose={onClose} scrollBehavior={noscroll ? 'inside' : 'outside'}>
      <ModalOverlay />
      <ModalContent ref={containerRef} width={width || 'md'} maxWidth="calc(100vw - 16px)" height={noscroll ? '100%' : 'unset'}>
        {!headless && <>
          <ModalHeader display='flex' alignItems='center' gap={2} fontWeight={500}>{title}</ModalHeader>
          <ModalCloseButton />
        </>}
        <ModalBody display='flex' gap={4} flexDirection='column' >
          {children}
        </ModalBody>
        {!footerless && <ModalFooter>
          {actions}
        </ModalFooter>}
        {loading && <Box 
          position='absolute' backgroundColor='whiteAlpha.500' top={0} left={0} right={0} bottom={0}
          display='flex' alignItems='center' justifyContent='center'
        >
          <Spinner />
        </Box>}
      </ModalContent>
    </Modal>
  </LayoutContext.Provider>);
};

export const Dialog = memo(DialogComponent);

export default memo(DialogComponent);
